module.exports = __webpack_public_path__ + "static/img/nyjn.1f4a6be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newHome/nyjn.png
// module id = kTYj
// module chunks = 1